import axios from 'axios'
import { Toast } from 'vant'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 可在此处添加token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    
    // 显示loading
    if (config.showLoading !== false) {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
    }
    
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 关闭loading
    Toast.clear()
    
    const res = response.data
    if (res.code !== 200) {
      // 错误处理
      Toast.fail(res.message || '请求失败')
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    // 关闭loading
    Toast.clear()
    
    // 错误处理
    if (error.response) {
      switch (error.response.status) {
        case 401:
          Toast.fail('登录过期，请重新登录')
          // 跳转到登录页
          break
        case 403:
          Toast.fail('拒绝访问')
          break
        case 404:
          Toast.fail('请求资源不存在')
          break
        case 500:
          Toast.fail('服务器错误')
          break
        default:
          Toast.fail(error.response.data.message || '请求错误')
      }
    } else {
      Toast.fail('网络异常，请检查网络连接')
    }
    
    return Promise.reject(error)
  }
)

export default service